import BrowserCompatability from "../../helper/compatability/browserCompatability";
import VersionCompatability from "../../helper/compatability/versionCompatability";
import TroopMovementType from "../enum/troopMovementType";
import {between} from "./util/util";
import ServertimeParser from "./servertimeParser";
import jQuery from "jquery";

export const MovingTroopsParser = {
    browsers: new BrowserCompatability(true, null, null),
    versions: new VersionCompatability(true, false),

    parseLegends: ($) => {
        const troopRows = $.find('.rallyPointOverviewContainer .troop_details').toArray();
        return troopRows.map(row => {
            const $row = jQuery(row);

            let type;
            switch (true) {
                case $row.hasClass('inAttack'):
                    type = TroopMovementType.incomingAttack;
                    break;
                case $row.hasClass('inRaid'):
                    type = TroopMovementType.incomingRaid;
                    break;
                case $row.hasClass('inSupply'):
                    type = TroopMovementType.incomingReinforcement;
                    break;
                case $row.hasClass('outAttack'):
                    type = TroopMovementType.outgoingAttack;
                    break;
                case $row.hasClass('outRaid'):
                    type = TroopMovementType.outgoingRaid;
                    break;
                case $row.hasClass('outSupply'):
                    type = TroopMovementType.outgoingReinforcement;
                    break;
                default:
                    // Stationary has no extra class. We assign it here, but filter these rows out later.
                    type = TroopMovementType.stationary;
                    break;
            }

            if (type === TroopMovementType.stationary) {
                return null;
            }

            const sourceMapId = between($row.find('.role a')[0].href, 'd=');
            const targetMapId = between($row.find('.troopHeadline a:not(.markAttack)')[0].href, 'd=');

            const impactInSeconds = Number($row.find('.infos .in .timer')[0].getAttribute('value'));
            const currentServerTime = ServertimeParser.parseLegends($);
            const impactTime = impactInSeconds + currentServerTime;

            const additionalData = {
                movementId: null
            };

            if (TroopMovementType.isHostileIncoming(type)) {
                const imageElementCandidates = $row.find('img.markAttack');
                if (imageElementCandidates.length > 0) {
                    const imageElement = imageElementCandidates[0];
                    const imageId = imageElement.id;
                    if (imageId) {
                        additionalData.movementId = imageId.split('_')[1];
                    }
                }
            }

            return {
                sourceMapId,
                targetMapId,
                impactTime,
                type,
                ...additionalData
            }
        }).filter(k => k !== null);
    },

    parseKingdoms: () => {

    }
};
